var map = {
	"./Austria, Italy, Germany 2025/GOPR1412.JPG": 336,
	"./Austria, Italy, Germany 2025/IMG_1109.jpg": 800,
	"./Austria, Italy, Germany 2025/cover.jpg": 442,
	"./Colorado, Wyoming, Montana 2019/cover.jpg": 457,
	"./Colorado, Wyoming, Montana 2019/image1.jpg": 994,
	"./Colorado, Wyoming, Montana 2019/image4.jpg": 691,
	"./Colorado, Wyoming, Montana 2019/image5.jpg": 430,
	"./Eastern Europe 2024/IMG_0180.jpg": 552,
	"./Eastern Europe 2024/IMG_0206.jpg": 761,
	"./Eastern Europe 2024/cover.jpg": 460,
	"./Germany, Austria, Italy, Switzerland 2022/IMG_8085.jpg": 520,
	"./Germany, Austria, Italy, Switzerland 2022/IMG_8115.jpg": 954,
	"./Germany, Austria, Italy, Switzerland 2022/IMG_8123.jpg": 401,
	"./Germany, Austria, Italy, Switzerland 2022/cover.jpg": 24,
	"./London 2025/IMG_0469.jpg": 365,
	"./London 2025/IMG_0687.jpg": 135,
	"./London 2025/IMG_0712.jpg": 672,
	"./London 2025/cover.jpg": 61,
	"./Pyrenees 2023/IMG_9139.jpg": 601,
	"./Pyrenees 2023/IMG_9255.jpg": 212,
	"./Pyrenees 2023/IMG_9295.jpg": 264,
	"./Pyrenees 2023/IMG_9318.jpg": 224,
	"./Pyrenees 2023/cover.jpg": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;